module.exports = __webpack_public_path__ + "img/2-2.a7e25de3.svg";